import { render, staticRenderFns } from "./LargeBtn.vue?vue&type=template&id=09c8026f&scoped=true&"
import script from "./LargeBtn.vue?vue&type=script&lang=js&"
export * from "./LargeBtn.vue?vue&type=script&lang=js&"
import style0 from "./LargeBtn.vue?vue&type=style&index=0&id=09c8026f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c8026f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
